import header from 'i18n/default/it/header.json';
import mainMenu from 'i18n/default/it/mainMenu';
import pendingPaymentAdvice from 'i18n/default/it/pendingPaymentAdvice';
import PalletType from 'i18n/default/it/PalletType';
import LiteralCurrency from 'i18n/default/it/LiteralCurrency';
import units from 'i18n/default/it/units';
import CustomPalletSize from 'i18n/default/it/CustomPalletSize';
import NumberOfItems from 'i18n/default/it/NumberOfItems';
import LoadInfo from 'i18n/default/it/LoadInfo';
import LoadInputs from 'i18n/default/it/LoadInputs';
import dates from 'i18n/default/it/dates';
import Addresses from 'i18n/default/it/Addresses';
import AddressFormModal from 'i18n/default/it/AddressFormModal';
import AddressSelector from 'i18n/default/it/AddressSelector';
import StopAddress from 'i18n/default/it/StopAddress';
import Quote from 'i18n/default/it/Quote';
import extraNames from 'i18n/default/it/extraNames';
import timePickers from 'i18n/default/it/timePickers';
import authLoginForm from 'i18n/default/it/authLoginForm';
import authSignUpForm from 'i18n/default/it/authSignUpForm';
import HandlingExtra from 'i18n/default/it/HandlingExtra';
import Stop from 'i18n/default/it/Stop';
import VehicleExtras from 'i18n/default/it/VehicleExtras';
import OrderStop from 'i18n/default/it/OrderStop';
import ShipmentCard from 'i18n/default/it/ShipmentCard';
import Orders from 'i18n/default/it/Orders';
import Summary from 'i18n/default/it/Summary';
import Login from 'i18n/default/it/Login';
import AddressesPage from 'i18n/default/it/AddressesPage';
import ModalSummary from 'i18n/default/it/ModalSummary';
import OrderSummary from 'i18n/default/it/OrderSummary';
import OrdersOrderDetail from 'i18n/default/it/OrdersOrderDetail';
import Order from 'i18n/default/it/Order';
import ModalOrderDetail from 'i18n/default/it/ModalOrderDetail';
import loads from 'i18n/default/it/loads';
import SuggestedTimes from 'i18n/default/it/SuggestedTimes';
import Downloads from 'i18n/default/it/Downloads';
import CreditCard from 'i18n/default/it/CreditCard';
import TypeOfOrderSelector from 'i18n/default/it/TypeOfOrderSelector';
import Recurring from 'i18n/default/it/Recurring';
import Settings from 'i18n/default/it/Settings';
import InviteUserModal from 'i18n/default/it/InviteUserModal';
import PaymentData from 'i18n/default/it/PaymentData';
import DriverMapError from 'i18n/default/it/DriverMapError';
import Faqs from 'i18n/default/it/Faqs';
import AdditionalDocuments from 'i18n/default/it/AdditionalDocuments';
import Communications from 'i18n/default/it/Communications';
import RecurringOrderSuggestions from 'i18n/default/it/RecurringOrderSuggestions';
import Error from 'i18n/default/it/Error';
import Users from 'i18n/default/it/Users';
import Tracking from 'i18n/default/it/Tracking';
import Dashboard from 'i18n/default/it/Dashboard';
import Catalog from 'i18n/default/it/Catalog';
import Emergencies from 'i18n/default/it/Emergencies';
import SignUp from 'i18n/default/it/SignUp';
import Profile from 'i18n/default/it/Profile';
import Landing from 'i18n/default/it/Landing';

const lang = {
  Emergencies,
  Catalog,
  header,
  mainMenu,
  pendingPaymentAdvice,
  PalletType,
  LiteralCurrency,
  units,
  CustomPalletSize,
  NumberOfItems,
  LoadInfo,
  LoadInputs,
  dates,
  AddressFormModal,
  AddressSelector,
  StopAddress,
  Quote,
  extraNames,
  timePickers,
  authLoginForm,
  authSignUpForm,
  HandlingExtra,
  Stop,
  VehicleExtras,
  OrderStop,
  ShipmentCard,
  Orders,
  Summary,
  Login,
  AddressesPage,
  OrdersOrderDetail,
  ModalSummary,
  OrderSummary,
  Order,
  ModalOrderDetail,
  loads,
  SuggestedTimes,
  Downloads,
  CreditCard,
  Addresses,
  TypeOfOrderSelector,
  Recurring,
  Settings,
  InviteUserModal,
  PaymentData,
  DriverMapError,
  Faqs,
  AdditionalDocuments,
  Communications,
  RecurringOrderSuggestions,
  Error,
  Users,
  Tracking,
  Dashboard,
  SignUp,
  Profile,
  Landing
};

export default lang;
